import { fieldProductSelection } from "../utils/constant";
import stringInterpolation from "../utils/stringInterpolation";

export const getFieldOption = (option, fieldName, fields) =>
fields &&
  Object.prototype.hasOwnProperty.call(fields, fieldName) &&
  fields[fieldName].isVisible
  ? fields[fieldName][option]
  : '';

export const disableOptions = (disable, currentFormFields) => {
    const isFormFields = currentFormFields && currentFormFields[fieldProductSelection] && currentFormFields[fieldProductSelection].options.length > 0;
    return isFormFields && currentFormFields[fieldProductSelection].options.map(option => {
      const op = option;
      op.fields.disabledOption = disable;
      return option;
    });
  };

    // Error messages
export const msgDisplay = (value,message) => stringInterpolation(message, value);

export const getFieldName = field => {
    return field && field.fields ? field.fields.name : '';
};

export const getFieldValue = (fieldName, fields) =>
getFieldOption('value', fieldName, fields);

export const getFieldType = (fieldName, fields) =>
getFieldOption('type', fieldName, fields);

export const getFieldChecked = (fieldName, fields) =>
getFieldOption('checked', fieldName, fields);
